import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const loadingToast = toast.loading('Enviando link...');
    try {
      const response = await api.post('/auth/forgot-password', { email });
      toast.dismiss(loadingToast);
      toast.success(response.data.message);
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error.response?.data?.error || 'Ocorreu um erro.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Redefinir Senha</h2>
      <p style={{color: 'var(--text-secondary)', marginTop: '-1rem', marginBottom: '2rem'}}>Digite seu e-mail e enviaremos um link para você criar uma nova senha.</p>
      <form onSubmit={handleSubmit}>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Seu e-mail de cadastro" required />
        <button type="submit" disabled={isLoading}>{isLoading ? 'Enviando...' : 'Enviar Link de Redefinição'}</button>
      </form>
      <p><Link to="/login">Voltar para o Login</Link></p>
    </div>
  );
}
export default ForgotPasswordPage;